/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Ampli - A strong typed wrapper for your Analytics
 *
 * This file is generated by Amplitude.
 * To update run 'ampli pull app'
 *
 * Required dependencies: @amplitude/analytics-browser@^1.3.0
 * Tracking Plan Version: 2
 * Build: 1.0.0
 * Runtime: browser:typescript-ampli-v2
 *
 * [View Tracking Plan](https://data.amplitude.com/clearitty/Clearitty/events/main/latest)
 *
 * [Full Setup Instructions](https://data.amplitude.com/clearitty/Clearitty/implementation/app)
 */

import * as amplitude from '@amplitude/analytics-browser';

export type Environment = 'clearitty';

export const ApiKey: Record<Environment, string> = {
  clearitty: '4423b5487c9b0689afd3e5041248c629'
};

/**
 * Default Amplitude configuration options. Contains tracking plan information.
 */
export const DefaultConfiguration: BrowserOptions = {
  plan: {
    version: '2',
    branch: 'main',
    source: 'app',
    versionId: 'feb3e296-c2b3-4e9f-9d9b-3f9d1acef9ab'
  },
  ...{
    ingestionMetadata: {
      sourceName: 'browser-typescript-ampli',
      sourceVersion: '2.0.0'
    }
  }
};

export interface LoadOptionsBase { disabled?: boolean }

export type LoadOptionsWithEnvironment = LoadOptionsBase & { environment: Environment; client?: { configuration?: BrowserOptions; }; };
export type LoadOptionsWithApiKey = LoadOptionsBase & { client: { apiKey: string; configuration?: BrowserOptions; } };
export type LoadOptionsWithClientInstance = LoadOptionsBase & { client: { instance: BrowserClient; } };

export type LoadOptions = LoadOptionsWithEnvironment | LoadOptionsWithApiKey | LoadOptionsWithClientInstance;

export interface IdentifyProperties {
  anonEmail?: string;
  email?: string;
  name?: string;
  utm_medium?: string;
}

export interface AddToListFromCompaniesProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  companyId?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  companyName?: string;
  listId: string;
  listName: string;
}

export interface AddToListFromContactsProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  contactCount: number;
  listId: string;
  listName: string;
  source: string;
  timestamp: any;
}

export interface AddToListFromListsProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  contactCount: number;
  listId: string;
  listName: string;
  source: string;
  timestamp: any;
}

export interface AddToListFromStakeholdersProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  contactCount: number;
  listId: string;
  listName: string;
  source: string;
  timestamp: any;
}

export interface AppPageViewedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Session Replay ID"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  pagePath?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  pageTitle?: string;
  params?: any;
}

export interface ChatCompanySelectedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Session Replay ID"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  companyId?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  companyName?: string;
  isPurchased?: boolean;
}

export interface ChatDeletedProperties {
  chatId: string;
}

export interface ChatStepSelectedProperties {
  chatId: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  companyId?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  companyName?: string;
  isPurchased?: boolean;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  step?: string;
}

export interface CheckoutStartedProperties {
  isYearly: boolean;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  monthlyCredits: number;
  planId: string;
}

export interface CompanyContactsExportedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  contactCount: number;
  exportType: string;
  timestamp: any;
}

export interface CompanyLinkClickedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  companyId?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  companyName?: string;
  source: string;
}

export interface CompanyPageEngagementActionProperties {
  action: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  companyId?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  companyName?: string;
  itemId: string;
  itemTitle: string;
  itemType: string;
}

export interface CompanyPageUnlockProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Session Replay ID"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  companyId?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  companyName?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  creditsRemaining?: number;
  isGift?: boolean;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  userId?: string;
}

export interface CompanyPageUnlockClosedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Session Replay ID"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  companyId?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  companyName?: string;
}

export interface CompanyPageUnlockOpenedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Session Replay ID"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  companyId?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  companyName?: string;
}

export interface CompanyPageViewProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Session Replay ID"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  companyId?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  companyName?: string;
  isPublished?: boolean;
  isPurchased?: boolean;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  section?: string;
}

export interface CompanyTourStepProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  companyId?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  companyName?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  stepName?: string;
}

export interface CreateNewListFromContactsProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  contactCount: number;
  listId: string;
  listName: string;
  source: string;
  timestamp: any;
}

export interface CreateNewListFromStakeholdersProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  contactCount: number;
  listId: string;
  listName: string;
  source: string;
  timestamp: any;
}

export interface DiscountAppliedProperties {
  utmMedium: string;
}

export interface DiscoverySortProperties {
  listName: string;
  sortField: string;
  sortOrder: string;
  sortValue: string;
  timestamp: any;
}

export interface EmptyCompanySearchResultProperties {
  searchTerm: string;
}

export interface FilterUsedProperties {
  filterName: string;
  filterType: string;
  filterValue: string;
  page: string;
  timestamp: any;
}

export interface GiftCardRedeemedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Session Replay ID"?: string;
  token: string;
}

export interface IndividualListExportedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  contactCount: number;
  exportType: string;
  listName: string;
  timestamp: any;
}

export interface IntegrationRequestedProperties {
  integrationName: string;
}

export interface InterestingCompanyAddedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Session Replay ID"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  companyId?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  companyName?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  userId?: string;
}

export interface InterestingCompanyRemovedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Session Replay ID"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  companyId?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  companyName?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  userId?: string;
}

export interface ListCreatedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  contactCount: number;
  listId: string;
  listName: string;
  timestamp: any;
}

export interface ListDeletedProperties {
  contactCount: string;
  listId: string;
  listName: string;
  timestamp: any;
}

export interface ListOpenedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  contactCount: number;
  listId: string;
  listName: string;
  timestamp: any;
}

export interface ListRenamedProperties {
  listId: string;
  newName: string;
  oldName: string;
  timestamp: any;
}

export interface LoginButtonClickedProperties {
  provider: string;
}

export interface MultipleListsExportedProperties {
  exportType: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  listCount: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  listIds: string[];
  /**
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  listNames: string[];
  timestamp: any;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  totalContactCount: number;
}

export interface OnboardingStepDoneProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Session Replay ID"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  stepName?: string;
  success?: boolean;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  version?: number;
}

export interface OnboardingStepStartProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  stepName?: string;
}

export interface PlanUpdateProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  credits: number;
  isYearly: boolean;
}

export interface QuestionnaireDoneProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  companyId?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  companyName?: string;
  departmentId: string;
  departmentName?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  questionnaireId?: string;
}

export interface QuestionnaireDraftSavedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  companyId?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  companyName?: string;
  departmentId: string;
  departmentName?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  questionnaireId?: string;
}

export interface QuestionnaireRedirectProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Session Replay ID"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  questionnaireId?: string;
}

export interface RecommendedCompanyAddedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  companyId?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  companyName?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  userId?: string;
}

export interface RemoveFromListProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  companyId?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  companyName?: string;
  listId: string;
  listName: string;
}

export interface RequestedCompanyProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  companyName?: string;
}

export interface SessionStartProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Session Replay ID"?: string;
}

export interface SignupButtonClickedProperties {
  provider: string;
}

export interface StakeholderReportGenerateCancelledProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  companyId?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  companyName?: string;
  departmentId: string;
}

export interface StakeholderReportGenerateRequestProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  companyId?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  companyName?: string;
  departmentId: string;
}

export interface TooltipClickedProperties {
  title?: string;
}

export interface UpgradeNowClickedProperties {
  ctaName?: string;
}

export interface UserLoginProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Session Replay ID"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  method?: string;
}

export interface UserLogoutProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Session Replay ID"?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  userId?: string;
}

export interface UserSignupProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  method?: string;
}

export class Identify implements BaseEvent {
  event_type = amplitude.Types.SpecialEventType.IDENTIFY;

  constructor(
    public event_properties?: IdentifyProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class AddToListFromCompanies implements BaseEvent {
  event_type = 'Add to List from Companies';

  constructor(
    public event_properties: AddToListFromCompaniesProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class AddToListFromContacts implements BaseEvent {
  event_type = 'Add to List from Contacts';

  constructor(
    public event_properties: AddToListFromContactsProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class AddToListFromLists implements BaseEvent {
  event_type = 'Add to List from Lists';

  constructor(
    public event_properties: AddToListFromListsProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class AddToListFromStakeholders implements BaseEvent {
  event_type = 'Add to List from Stakeholders';

  constructor(
    public event_properties: AddToListFromStakeholdersProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class AppPageViewed implements BaseEvent {
  event_type = 'App Page Viewed';

  constructor(
    public event_properties?: AppPageViewedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class CancelSubscription implements BaseEvent {
  event_type = 'Cancel Subscription';
}

export class ChatCompanySelected implements BaseEvent {
  event_type = 'Chat Company Selected';

  constructor(
    public event_properties?: ChatCompanySelectedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ChatDeleted implements BaseEvent {
  event_type = 'Chat Deleted';

  constructor(
    public event_properties: ChatDeletedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ChatStepSelected implements BaseEvent {
  event_type = 'Chat Step Selected';

  constructor(
    public event_properties: ChatStepSelectedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class CheckoutStarted implements BaseEvent {
  event_type = 'Checkout Started';

  constructor(
    public event_properties: CheckoutStartedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class CompanyContactsExported implements BaseEvent {
  event_type = 'Company Contacts Exported';

  constructor(
    public event_properties: CompanyContactsExportedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class CompanyLinkClicked implements BaseEvent {
  event_type = 'Company Link Clicked';

  constructor(
    public event_properties: CompanyLinkClickedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class CompanyPageEngagementAction implements BaseEvent {
  event_type = 'Company Page Engagement Action';

  constructor(
    public event_properties: CompanyPageEngagementActionProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class CompanyPageUnlock implements BaseEvent {
  event_type = 'Company Page Unlock';

  constructor(
    public event_properties?: CompanyPageUnlockProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class CompanyPageUnlockClosed implements BaseEvent {
  event_type = 'Company Page Unlock Closed';

  constructor(
    public event_properties?: CompanyPageUnlockClosedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class CompanyPageUnlockOpened implements BaseEvent {
  event_type = 'Company Page Unlock Opened';

  constructor(
    public event_properties?: CompanyPageUnlockOpenedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class CompanyPageView implements BaseEvent {
  event_type = 'Company Page View';

  constructor(
    public event_properties?: CompanyPageViewProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class CompanyTourStep implements BaseEvent {
  event_type = 'Company Tour Step';

  constructor(
    public event_properties?: CompanyTourStepProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class CreateNewListFromContacts implements BaseEvent {
  event_type = 'Create New List from Contacts';

  constructor(
    public event_properties: CreateNewListFromContactsProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class CreateNewListFromStakeholders implements BaseEvent {
  event_type = 'Create New List from Stakeholders';

  constructor(
    public event_properties: CreateNewListFromStakeholdersProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class DiscountApplied implements BaseEvent {
  event_type = 'Discount Applied';

  constructor(
    public event_properties: DiscountAppliedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class DiscoverySort implements BaseEvent {
  event_type = 'Discovery Sort';

  constructor(
    public event_properties: DiscoverySortProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class DowngradePro implements BaseEvent {
  event_type = 'Downgrade Pro';
}

export class EmptyCompanySearchResult implements BaseEvent {
  event_type = 'Empty Company Search Result';

  constructor(
    public event_properties: EmptyCompanySearchResultProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ExtendTrial implements BaseEvent {
  event_type = 'Extend Trial';
}

export class FilterUsed implements BaseEvent {
  event_type = 'Filter Used';

  constructor(
    public event_properties: FilterUsedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class GiftCardRedeemed implements BaseEvent {
  event_type = 'Gift Card Redeemed';

  constructor(
    public event_properties: GiftCardRedeemedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class IndividualListExported implements BaseEvent {
  event_type = 'Individual List Exported';

  constructor(
    public event_properties: IndividualListExportedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class IntegrationRequested implements BaseEvent {
  event_type = 'Integration Requested';

  constructor(
    public event_properties: IntegrationRequestedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class InterestingCompanyAdded implements BaseEvent {
  event_type = 'Interesting Company Added';

  constructor(
    public event_properties?: InterestingCompanyAddedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class InterestingCompanyRemoved implements BaseEvent {
  event_type = 'Interesting Company Removed';

  constructor(
    public event_properties?: InterestingCompanyRemovedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ListCreated implements BaseEvent {
  event_type = 'List Created';

  constructor(
    public event_properties: ListCreatedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ListDeleted implements BaseEvent {
  event_type = 'List Deleted';

  constructor(
    public event_properties: ListDeletedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ListOpened implements BaseEvent {
  event_type = 'List Opened';

  constructor(
    public event_properties: ListOpenedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ListRenamed implements BaseEvent {
  event_type = 'List Renamed';

  constructor(
    public event_properties: ListRenamedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class LoginButtonClicked implements BaseEvent {
  event_type = 'Login Button Clicked';

  constructor(
    public event_properties: LoginButtonClickedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class MultipleListsExported implements BaseEvent {
  event_type = 'Multiple Lists Exported';

  constructor(
    public event_properties: MultipleListsExportedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class NewChat implements BaseEvent {
  event_type = 'New Chat';
}

export class OnboardingSkipped implements BaseEvent {
  event_type = 'Onboarding Skipped';
}

export class OnboardingStepDone implements BaseEvent {
  event_type = 'Onboarding Step Done';

  constructor(
    public event_properties?: OnboardingStepDoneProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class OnboardingStepStart implements BaseEvent {
  event_type = 'Onboarding Step Start';

  constructor(
    public event_properties?: OnboardingStepStartProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PlanUpdate implements BaseEvent {
  event_type = 'Plan Update';

  constructor(
    public event_properties: PlanUpdateProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class QuestionnaireDone implements BaseEvent {
  event_type = 'Questionnaire Done';

  constructor(
    public event_properties: QuestionnaireDoneProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class QuestionnaireDraftSaved implements BaseEvent {
  event_type = 'Questionnaire Draft Saved';

  constructor(
    public event_properties: QuestionnaireDraftSavedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class QuestionnaireRedirect implements BaseEvent {
  event_type = 'Questionnaire Redirect';

  constructor(
    public event_properties?: QuestionnaireRedirectProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class RecommendedCompanyAdded implements BaseEvent {
  event_type = 'Recommended Company Added';

  constructor(
    public event_properties?: RecommendedCompanyAddedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class RemoveFromList implements BaseEvent {
  event_type = 'Remove from List';

  constructor(
    public event_properties: RemoveFromListProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class RequestedCompany implements BaseEvent {
  event_type = 'Requested Company';

  constructor(
    public event_properties?: RequestedCompanyProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class SessionStart implements BaseEvent {
  event_type = 'session_start';

  constructor(
    public event_properties?: SessionStartProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class SignupButtonClicked implements BaseEvent {
  event_type = 'Signup Button Clicked';

  constructor(
    public event_properties: SignupButtonClickedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class StakeholderReportGenerateCancelled implements BaseEvent {
  event_type = 'Stakeholder Report Generate Cancelled';

  constructor(
    public event_properties: StakeholderReportGenerateCancelledProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class StakeholderReportGenerateRequest implements BaseEvent {
  event_type = 'Stakeholder Report Generate Request';

  constructor(
    public event_properties: StakeholderReportGenerateRequestProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class TooltipClicked implements BaseEvent {
  event_type = 'Tooltip Clicked';

  constructor(
    public event_properties?: TooltipClickedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class UpgradeNowClicked implements BaseEvent {
  event_type = 'Upgrade Now Clicked';

  constructor(
    public event_properties?: UpgradeNowClickedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class UserLogin implements BaseEvent {
  event_type = 'User Login';

  constructor(
    public event_properties?: UserLoginProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class UserLogout implements BaseEvent {
  event_type = 'User Logout';

  constructor(
    public event_properties?: UserLogoutProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class UserSignup implements BaseEvent {
  event_type = 'User Signup';

  constructor(
    public event_properties?: UserSignupProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export type PromiseResult<T> = { promise: Promise<T | void> };

const getVoidPromiseResult = () => ({ promise: Promise.resolve() });

// prettier-ignore
export class Ampli {
  private disabled: boolean = false;
  private amplitude?: BrowserClient;

  get client(): BrowserClient {
    this.isInitializedAndEnabled();
    return this.amplitude!;
  }

  get isLoaded(): boolean {
    return this.amplitude != null;
  }

  private isInitializedAndEnabled(): boolean {
    if (!this.amplitude) {
      console.error('ERROR: Ampli is not yet initialized. Have you called ampli.load() on app start?');
      return false;
    }
    return !this.disabled;
  }

  /**
   * Initialize the Ampli SDK. Call once when your application starts.
   *
   * @param options Configuration options to initialize the Ampli SDK with.
   */
  load(options: LoadOptions): PromiseResult<void> {
    this.disabled = options.disabled ?? false;

    if (this.amplitude) {
      console.warn('WARNING: Ampli is already intialized. Ampli.load() should be called once at application startup.');
      return getVoidPromiseResult();
    }

    let apiKey: string | null = null;
    if (options.client && 'apiKey' in options.client) {
      apiKey = options.client.apiKey;
    } else if ('environment' in options) {
      apiKey = ApiKey[options.environment];
    }

    if (options.client && 'instance' in options.client) {
      this.amplitude = options.client.instance;
    } else if (apiKey) {
      this.amplitude = amplitude.createInstance();
      const configuration = (options.client && 'configuration' in options.client) ? options.client.configuration : {};
      return this.amplitude.init(apiKey, undefined, { ...DefaultConfiguration, ...configuration });
    } else {
      console.error("ERROR: ampli.load() requires 'environment', 'client.apiKey', or 'client.instance'");
    }

    return getVoidPromiseResult();
  }

  /**
   * Identify a user and set user properties.
   *
   * @param userId The user's id.
   * @param properties The user properties.
   * @param options Optional event options.
   */
  identify(
    userId: string | undefined,
    properties?: IdentifyProperties,
    options?: EventOptions,
  ): PromiseResult<Result> {
    if (!this.isInitializedAndEnabled()) {
      return getVoidPromiseResult();
    }

    if (userId) {
      options = {...options,  user_id: userId};
    }

    const amplitudeIdentify = new amplitude.Identify();
    const eventProperties = properties;
    if (eventProperties != null) {
      for (const [key, value] of Object.entries(eventProperties)) {
        amplitudeIdentify.set(key, value);
      }
    }
    return this.amplitude!.identify(
      amplitudeIdentify,
      options,
    );
  }

 /**
  * Flush the event.
  */
  flush() : PromiseResult<Result> {
    if (!this.isInitializedAndEnabled()) {
      return getVoidPromiseResult();
    }

    return this.amplitude!.flush();
  }

  /**
   * Track event
   *
   * @param event The event to track.
   * @param options Optional event options.
   */
  track(event: Event, options?: EventOptions): PromiseResult<Result> {
    if (!this.isInitializedAndEnabled()) {
      return getVoidPromiseResult();
    }

    return this.amplitude!.track(event, undefined, options);
  }

  /**
   * Add to List from Companies
   *
   * [View in Tracking Plan](https://data.amplitude.com/clearitty/Clearitty/events/main/latest/Add%20to%20List%20from%20Companies)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. companyId)
   * @param options Amplitude event options.
   */
  addToListFromCompanies(
    properties: AddToListFromCompaniesProperties,
    options?: EventOptions,
  ) {
    return this.track(new AddToListFromCompanies(properties), options);
  }

  /**
   * Add to List from Contacts
   *
   * [View in Tracking Plan](https://data.amplitude.com/clearitty/Clearitty/events/main/latest/Add%20to%20List%20from%20Contacts)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. contactCount)
   * @param options Amplitude event options.
   */
  addToListFromContacts(
    properties: AddToListFromContactsProperties,
    options?: EventOptions,
  ) {
    return this.track(new AddToListFromContacts(properties), options);
  }

  /**
   * Add to List from Lists
   *
   * [View in Tracking Plan](https://data.amplitude.com/clearitty/Clearitty/events/main/latest/Add%20to%20List%20from%20Lists)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. contactCount)
   * @param options Amplitude event options.
   */
  addToListFromLists(
    properties: AddToListFromListsProperties,
    options?: EventOptions,
  ) {
    return this.track(new AddToListFromLists(properties), options);
  }

  /**
   * Add to List from Stakeholders
   *
   * [View in Tracking Plan](https://data.amplitude.com/clearitty/Clearitty/events/main/latest/Add%20to%20List%20from%20Stakeholders)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. contactCount)
   * @param options Amplitude event options.
   */
  addToListFromStakeholders(
    properties: AddToListFromStakeholdersProperties,
    options?: EventOptions,
  ) {
    return this.track(new AddToListFromStakeholders(properties), options);
  }

  /**
   * App Page Viewed
   *
   * [View in Tracking Plan](https://data.amplitude.com/clearitty/Clearitty/events/main/latest/App%20Page%20Viewed)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. [Amplitude] Session Replay ID)
   * @param options Amplitude event options.
   */
  appPageViewed(
    properties?: AppPageViewedProperties,
    options?: EventOptions,
  ) {
    return this.track(new AppPageViewed(properties), options);
  }

  /**
   * Cancel Subscription
   *
   * [View in Tracking Plan](https://data.amplitude.com/clearitty/Clearitty/events/main/latest/Cancel%20Subscription)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  cancelSubscription(
    options?: EventOptions,
  ) {
    return this.track(new CancelSubscription(), options);
  }

  /**
   * Chat Company Selected
   *
   * [View in Tracking Plan](https://data.amplitude.com/clearitty/Clearitty/events/main/latest/Chat%20Company%20Selected)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. [Amplitude] Session Replay ID)
   * @param options Amplitude event options.
   */
  chatCompanySelected(
    properties?: ChatCompanySelectedProperties,
    options?: EventOptions,
  ) {
    return this.track(new ChatCompanySelected(properties), options);
  }

  /**
   * Chat Deleted
   *
   * [View in Tracking Plan](https://data.amplitude.com/clearitty/Clearitty/events/main/latest/Chat%20Deleted)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. chatId)
   * @param options Amplitude event options.
   */
  chatDeleted(
    properties: ChatDeletedProperties,
    options?: EventOptions,
  ) {
    return this.track(new ChatDeleted(properties), options);
  }

  /**
   * Chat Step Selected
   *
   * [View in Tracking Plan](https://data.amplitude.com/clearitty/Clearitty/events/main/latest/Chat%20Step%20Selected)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. chatId)
   * @param options Amplitude event options.
   */
  chatStepSelected(
    properties: ChatStepSelectedProperties,
    options?: EventOptions,
  ) {
    return this.track(new ChatStepSelected(properties), options);
  }

  /**
   * Checkout Started
   *
   * [View in Tracking Plan](https://data.amplitude.com/clearitty/Clearitty/events/main/latest/Checkout%20Started)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. isYearly)
   * @param options Amplitude event options.
   */
  checkoutStarted(
    properties: CheckoutStartedProperties,
    options?: EventOptions,
  ) {
    return this.track(new CheckoutStarted(properties), options);
  }

  /**
   * Company Contacts Exported
   *
   * [View in Tracking Plan](https://data.amplitude.com/clearitty/Clearitty/events/main/latest/Company%20Contacts%20Exported)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. contactCount)
   * @param options Amplitude event options.
   */
  companyContactsExported(
    properties: CompanyContactsExportedProperties,
    options?: EventOptions,
  ) {
    return this.track(new CompanyContactsExported(properties), options);
  }

  /**
   * Company Link Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/clearitty/Clearitty/events/main/latest/Company%20Link%20Clicked)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. companyId)
   * @param options Amplitude event options.
   */
  companyLinkClicked(
    properties: CompanyLinkClickedProperties,
    options?: EventOptions,
  ) {
    return this.track(new CompanyLinkClicked(properties), options);
  }

  /**
   * Company Page Engagement Action
   *
   * [View in Tracking Plan](https://data.amplitude.com/clearitty/Clearitty/events/main/latest/Company%20Page%20Engagement%20Action)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. action)
   * @param options Amplitude event options.
   */
  companyPageEngagementAction(
    properties: CompanyPageEngagementActionProperties,
    options?: EventOptions,
  ) {
    return this.track(new CompanyPageEngagementAction(properties), options);
  }

  /**
   * Company Page Unlock
   *
   * [View in Tracking Plan](https://data.amplitude.com/clearitty/Clearitty/events/main/latest/Company%20Page%20Unlock)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. [Amplitude] Session Replay ID)
   * @param options Amplitude event options.
   */
  companyPageUnlock(
    properties?: CompanyPageUnlockProperties,
    options?: EventOptions,
  ) {
    return this.track(new CompanyPageUnlock(properties), options);
  }

  /**
   * Company Page Unlock Closed
   *
   * [View in Tracking Plan](https://data.amplitude.com/clearitty/Clearitty/events/main/latest/Company%20Page%20Unlock%20Closed)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. [Amplitude] Session Replay ID)
   * @param options Amplitude event options.
   */
  companyPageUnlockClosed(
    properties?: CompanyPageUnlockClosedProperties,
    options?: EventOptions,
  ) {
    return this.track(new CompanyPageUnlockClosed(properties), options);
  }

  /**
   * Company Page Unlock Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/clearitty/Clearitty/events/main/latest/Company%20Page%20Unlock%20Opened)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. [Amplitude] Session Replay ID)
   * @param options Amplitude event options.
   */
  companyPageUnlockOpened(
    properties?: CompanyPageUnlockOpenedProperties,
    options?: EventOptions,
  ) {
    return this.track(new CompanyPageUnlockOpened(properties), options);
  }

  /**
   * Company Page View
   *
   * [View in Tracking Plan](https://data.amplitude.com/clearitty/Clearitty/events/main/latest/Company%20Page%20View)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. [Amplitude] Session Replay ID)
   * @param options Amplitude event options.
   */
  companyPageView(
    properties?: CompanyPageViewProperties,
    options?: EventOptions,
  ) {
    return this.track(new CompanyPageView(properties), options);
  }

  /**
   * Company Tour Step
   *
   * [View in Tracking Plan](https://data.amplitude.com/clearitty/Clearitty/events/main/latest/Company%20Tour%20Step)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. companyId)
   * @param options Amplitude event options.
   */
  companyTourStep(
    properties?: CompanyTourStepProperties,
    options?: EventOptions,
  ) {
    return this.track(new CompanyTourStep(properties), options);
  }

  /**
   * Create New List from Contacts
   *
   * [View in Tracking Plan](https://data.amplitude.com/clearitty/Clearitty/events/main/latest/Create%20New%20List%20from%20Contacts)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. contactCount)
   * @param options Amplitude event options.
   */
  createNewListFromContacts(
    properties: CreateNewListFromContactsProperties,
    options?: EventOptions,
  ) {
    return this.track(new CreateNewListFromContacts(properties), options);
  }

  /**
   * Create New List from Stakeholders
   *
   * [View in Tracking Plan](https://data.amplitude.com/clearitty/Clearitty/events/main/latest/Create%20New%20List%20from%20Stakeholders)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. contactCount)
   * @param options Amplitude event options.
   */
  createNewListFromStakeholders(
    properties: CreateNewListFromStakeholdersProperties,
    options?: EventOptions,
  ) {
    return this.track(new CreateNewListFromStakeholders(properties), options);
  }

  /**
   * Discount Applied
   *
   * [View in Tracking Plan](https://data.amplitude.com/clearitty/Clearitty/events/main/latest/Discount%20Applied)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. utmMedium)
   * @param options Amplitude event options.
   */
  discountApplied(
    properties: DiscountAppliedProperties,
    options?: EventOptions,
  ) {
    return this.track(new DiscountApplied(properties), options);
  }

  /**
   * Discovery Sort
   *
   * [View in Tracking Plan](https://data.amplitude.com/clearitty/Clearitty/events/main/latest/Discovery%20Sort)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. listName)
   * @param options Amplitude event options.
   */
  discoverySort(
    properties: DiscoverySortProperties,
    options?: EventOptions,
  ) {
    return this.track(new DiscoverySort(properties), options);
  }

  /**
   * Downgrade Pro
   *
   * [View in Tracking Plan](https://data.amplitude.com/clearitty/Clearitty/events/main/latest/Downgrade%20Pro)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  downgradePro(
    options?: EventOptions,
  ) {
    return this.track(new DowngradePro(), options);
  }

  /**
   * Empty Company Search Result
   *
   * [View in Tracking Plan](https://data.amplitude.com/clearitty/Clearitty/events/main/latest/Empty%20Company%20Search%20Result)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. searchTerm)
   * @param options Amplitude event options.
   */
  emptyCompanySearchResult(
    properties: EmptyCompanySearchResultProperties,
    options?: EventOptions,
  ) {
    return this.track(new EmptyCompanySearchResult(properties), options);
  }

  /**
   * Extend Trial
   *
   * [View in Tracking Plan](https://data.amplitude.com/clearitty/Clearitty/events/main/latest/Extend%20Trial)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  extendTrial(
    options?: EventOptions,
  ) {
    return this.track(new ExtendTrial(), options);
  }

  /**
   * Filter Used
   *
   * [View in Tracking Plan](https://data.amplitude.com/clearitty/Clearitty/events/main/latest/Filter%20Used)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. filterName)
   * @param options Amplitude event options.
   */
  filterUsed(
    properties: FilterUsedProperties,
    options?: EventOptions,
  ) {
    return this.track(new FilterUsed(properties), options);
  }

  /**
   * Gift Card Redeemed
   *
   * [View in Tracking Plan](https://data.amplitude.com/clearitty/Clearitty/events/main/latest/Gift%20Card%20Redeemed)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. [Amplitude] Session Replay ID)
   * @param options Amplitude event options.
   */
  giftCardRedeemed(
    properties: GiftCardRedeemedProperties,
    options?: EventOptions,
  ) {
    return this.track(new GiftCardRedeemed(properties), options);
  }

  /**
   * Individual List Exported
   *
   * [View in Tracking Plan](https://data.amplitude.com/clearitty/Clearitty/events/main/latest/Individual%20List%20Exported)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. contactCount)
   * @param options Amplitude event options.
   */
  individualListExported(
    properties: IndividualListExportedProperties,
    options?: EventOptions,
  ) {
    return this.track(new IndividualListExported(properties), options);
  }

  /**
   * Integration Requested
   *
   * [View in Tracking Plan](https://data.amplitude.com/clearitty/Clearitty/events/main/latest/Integration%20Requested)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. integrationName)
   * @param options Amplitude event options.
   */
  integrationRequested(
    properties: IntegrationRequestedProperties,
    options?: EventOptions,
  ) {
    return this.track(new IntegrationRequested(properties), options);
  }

  /**
   * Interesting Company Added
   *
   * [View in Tracking Plan](https://data.amplitude.com/clearitty/Clearitty/events/main/latest/Interesting%20Company%20Added)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. [Amplitude] Session Replay ID)
   * @param options Amplitude event options.
   */
  interestingCompanyAdded(
    properties?: InterestingCompanyAddedProperties,
    options?: EventOptions,
  ) {
    return this.track(new InterestingCompanyAdded(properties), options);
  }

  /**
   * Interesting Company Removed
   *
   * [View in Tracking Plan](https://data.amplitude.com/clearitty/Clearitty/events/main/latest/Interesting%20Company%20Removed)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. [Amplitude] Session Replay ID)
   * @param options Amplitude event options.
   */
  interestingCompanyRemoved(
    properties?: InterestingCompanyRemovedProperties,
    options?: EventOptions,
  ) {
    return this.track(new InterestingCompanyRemoved(properties), options);
  }

  /**
   * List Created
   *
   * [View in Tracking Plan](https://data.amplitude.com/clearitty/Clearitty/events/main/latest/List%20Created)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. contactCount)
   * @param options Amplitude event options.
   */
  listCreated(
    properties: ListCreatedProperties,
    options?: EventOptions,
  ) {
    return this.track(new ListCreated(properties), options);
  }

  /**
   * List Deleted
   *
   * [View in Tracking Plan](https://data.amplitude.com/clearitty/Clearitty/events/main/latest/List%20Deleted)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. contactCount)
   * @param options Amplitude event options.
   */
  listDeleted(
    properties: ListDeletedProperties,
    options?: EventOptions,
  ) {
    return this.track(new ListDeleted(properties), options);
  }

  /**
   * List Opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/clearitty/Clearitty/events/main/latest/List%20Opened)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. contactCount)
   * @param options Amplitude event options.
   */
  listOpened(
    properties: ListOpenedProperties,
    options?: EventOptions,
  ) {
    return this.track(new ListOpened(properties), options);
  }

  /**
   * List Renamed
   *
   * [View in Tracking Plan](https://data.amplitude.com/clearitty/Clearitty/events/main/latest/List%20Renamed)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. listId)
   * @param options Amplitude event options.
   */
  listRenamed(
    properties: ListRenamedProperties,
    options?: EventOptions,
  ) {
    return this.track(new ListRenamed(properties), options);
  }

  /**
   * Login Button Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/clearitty/Clearitty/events/main/latest/Login%20Button%20Clicked)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. provider)
   * @param options Amplitude event options.
   */
  loginButtonClicked(
    properties: LoginButtonClickedProperties,
    options?: EventOptions,
  ) {
    return this.track(new LoginButtonClicked(properties), options);
  }

  /**
   * Multiple Lists Exported
   *
   * [View in Tracking Plan](https://data.amplitude.com/clearitty/Clearitty/events/main/latest/Multiple%20Lists%20Exported)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. exportType)
   * @param options Amplitude event options.
   */
  multipleListsExported(
    properties: MultipleListsExportedProperties,
    options?: EventOptions,
  ) {
    return this.track(new MultipleListsExported(properties), options);
  }

  /**
   * New Chat
   *
   * [View in Tracking Plan](https://data.amplitude.com/clearitty/Clearitty/events/main/latest/New%20Chat)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  newChat(
    options?: EventOptions,
  ) {
    return this.track(new NewChat(), options);
  }

  /**
   * Onboarding Skipped
   *
   * [View in Tracking Plan](https://data.amplitude.com/clearitty/Clearitty/events/main/latest/Onboarding%20Skipped)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  onboardingSkipped(
    options?: EventOptions,
  ) {
    return this.track(new OnboardingSkipped(), options);
  }

  /**
   * Onboarding Step Done
   *
   * [View in Tracking Plan](https://data.amplitude.com/clearitty/Clearitty/events/main/latest/Onboarding%20Step%20Done)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. [Amplitude] Session Replay ID)
   * @param options Amplitude event options.
   */
  onboardingStepDone(
    properties?: OnboardingStepDoneProperties,
    options?: EventOptions,
  ) {
    return this.track(new OnboardingStepDone(properties), options);
  }

  /**
   * Onboarding Step Start
   *
   * [View in Tracking Plan](https://data.amplitude.com/clearitty/Clearitty/events/main/latest/Onboarding%20Step%20Start)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. stepName)
   * @param options Amplitude event options.
   */
  onboardingStepStart(
    properties?: OnboardingStepStartProperties,
    options?: EventOptions,
  ) {
    return this.track(new OnboardingStepStart(properties), options);
  }

  /**
   * Plan Update
   *
   * [View in Tracking Plan](https://data.amplitude.com/clearitty/Clearitty/events/main/latest/Plan%20Update)
   *
   * Owner: Regev Azriel
   *
   * @param properties The event's properties (e.g. credits)
   * @param options Amplitude event options.
   */
  planUpdate(
    properties: PlanUpdateProperties,
    options?: EventOptions,
  ) {
    return this.track(new PlanUpdate(properties), options);
  }

  /**
   * Questionnaire Done
   *
   * [View in Tracking Plan](https://data.amplitude.com/clearitty/Clearitty/events/main/latest/Questionnaire%20Done)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. companyId)
   * @param options Amplitude event options.
   */
  questionnaireDone(
    properties: QuestionnaireDoneProperties,
    options?: EventOptions,
  ) {
    return this.track(new QuestionnaireDone(properties), options);
  }

  /**
   * Questionnaire Draft Saved
   *
   * [View in Tracking Plan](https://data.amplitude.com/clearitty/Clearitty/events/main/latest/Questionnaire%20Draft%20Saved)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. companyId)
   * @param options Amplitude event options.
   */
  questionnaireDraftSaved(
    properties: QuestionnaireDraftSavedProperties,
    options?: EventOptions,
  ) {
    return this.track(new QuestionnaireDraftSaved(properties), options);
  }

  /**
   * Questionnaire Redirect
   *
   * [View in Tracking Plan](https://data.amplitude.com/clearitty/Clearitty/events/main/latest/Questionnaire%20Redirect)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. [Amplitude] Session Replay ID)
   * @param options Amplitude event options.
   */
  questionnaireRedirect(
    properties?: QuestionnaireRedirectProperties,
    options?: EventOptions,
  ) {
    return this.track(new QuestionnaireRedirect(properties), options);
  }

  /**
   * Recommended Company Added
   *
   * [View in Tracking Plan](https://data.amplitude.com/clearitty/Clearitty/events/main/latest/Recommended%20Company%20Added)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. companyId)
   * @param options Amplitude event options.
   */
  recommendedCompanyAdded(
    properties?: RecommendedCompanyAddedProperties,
    options?: EventOptions,
  ) {
    return this.track(new RecommendedCompanyAdded(properties), options);
  }

  /**
   * Remove from List
   *
   * [View in Tracking Plan](https://data.amplitude.com/clearitty/Clearitty/events/main/latest/Remove%20from%20List)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. companyId)
   * @param options Amplitude event options.
   */
  removeFromList(
    properties: RemoveFromListProperties,
    options?: EventOptions,
  ) {
    return this.track(new RemoveFromList(properties), options);
  }

  /**
   * Requested Company
   *
   * [View in Tracking Plan](https://data.amplitude.com/clearitty/Clearitty/events/main/latest/Requested%20Company)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. companyName)
   * @param options Amplitude event options.
   */
  requestedCompany(
    properties?: RequestedCompanyProperties,
    options?: EventOptions,
  ) {
    return this.track(new RequestedCompany(properties), options);
  }

  /**
   * session_start
   *
   * [View in Tracking Plan](https://data.amplitude.com/clearitty/Clearitty/events/main/latest/session_start)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. [Amplitude] Session Replay ID)
   * @param options Amplitude event options.
   */
  sessionStart(
    properties?: SessionStartProperties,
    options?: EventOptions,
  ) {
    return this.track(new SessionStart(properties), options);
  }

  /**
   * Signup Button Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/clearitty/Clearitty/events/main/latest/Signup%20Button%20Clicked)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. provider)
   * @param options Amplitude event options.
   */
  signupButtonClicked(
    properties: SignupButtonClickedProperties,
    options?: EventOptions,
  ) {
    return this.track(new SignupButtonClicked(properties), options);
  }

  /**
   * Stakeholder Report Generate Cancelled
   *
   * [View in Tracking Plan](https://data.amplitude.com/clearitty/Clearitty/events/main/latest/Stakeholder%20Report%20Generate%20Cancelled)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. companyId)
   * @param options Amplitude event options.
   */
  stakeholderReportGenerateCancelled(
    properties: StakeholderReportGenerateCancelledProperties,
    options?: EventOptions,
  ) {
    return this.track(new StakeholderReportGenerateCancelled(properties), options);
  }

  /**
   * Stakeholder Report Generate Request
   *
   * [View in Tracking Plan](https://data.amplitude.com/clearitty/Clearitty/events/main/latest/Stakeholder%20Report%20Generate%20Request)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. companyId)
   * @param options Amplitude event options.
   */
  stakeholderReportGenerateRequest(
    properties: StakeholderReportGenerateRequestProperties,
    options?: EventOptions,
  ) {
    return this.track(new StakeholderReportGenerateRequest(properties), options);
  }

  /**
   * Tooltip Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/clearitty/Clearitty/events/main/latest/Tooltip%20Clicked)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. title)
   * @param options Amplitude event options.
   */
  tooltipClicked(
    properties?: TooltipClickedProperties,
    options?: EventOptions,
  ) {
    return this.track(new TooltipClicked(properties), options);
  }

  /**
   * Upgrade Now Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/clearitty/Clearitty/events/main/latest/Upgrade%20Now%20Clicked)
   *
   * Owner: Regev Azriel
   *
   * @param properties The event's properties (e.g. ctaName)
   * @param options Amplitude event options.
   */
  upgradeNowClicked(
    properties?: UpgradeNowClickedProperties,
    options?: EventOptions,
  ) {
    return this.track(new UpgradeNowClicked(properties), options);
  }

  /**
   * User Login
   *
   * [View in Tracking Plan](https://data.amplitude.com/clearitty/Clearitty/events/main/latest/User%20Login)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. [Amplitude] Session Replay ID)
   * @param options Amplitude event options.
   */
  userLogin(
    properties?: UserLoginProperties,
    options?: EventOptions,
  ) {
    return this.track(new UserLogin(properties), options);
  }

  /**
   * User Logout
   *
   * [View in Tracking Plan](https://data.amplitude.com/clearitty/Clearitty/events/main/latest/User%20Logout)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. [Amplitude] Session Replay ID)
   * @param options Amplitude event options.
   */
  userLogout(
    properties?: UserLogoutProperties,
    options?: EventOptions,
  ) {
    return this.track(new UserLogout(properties), options);
  }

  /**
   * User Signup
   *
   * [View in Tracking Plan](https://data.amplitude.com/clearitty/Clearitty/events/main/latest/User%20Signup)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. method)
   * @param options Amplitude event options.
   */
  userSignup(
    properties?: UserSignupProperties,
    options?: EventOptions,
  ) {
    return this.track(new UserSignup(properties), options);
  }
}

export const ampli = new Ampli();

// BASE TYPES
type BrowserOptions = amplitude.Types.BrowserOptions;

export type BrowserClient = amplitude.Types.BrowserClient;
export type BaseEvent = amplitude.Types.BaseEvent;
export type IdentifyEvent = amplitude.Types.IdentifyEvent;
export type GroupEvent = amplitude.Types.GroupIdentifyEvent;
export type Event = amplitude.Types.Event;
export type EventOptions = amplitude.Types.EventOptions;
export type Result = amplitude.Types.Result;
